window.ttx = window.ttx || {};
ttx.proxy = {};

/**
 * 请求转发
 * @param {*} props 保留参数，兼容现有 tx 方法签名
 * @param {*} params { url, method, query, headers, timeout, async }
 * @param {*} data 请求体
 * @param {*} callback 回调 (res, err)
 */
ttx.proxy.forward = function (props, params, data, callback) {
    const options = params || {};
    const url = options.url;

    if (!url) {
        const err = new Error('proxy forward: params.url is required');
        if (typeof callback === 'function') callback(null, err);
        return;
    }

    const method = (options.method || 'post').toUpperCase();
    const query = options.query ? ttx.utils.transferQuery(options.query) : '';

    ttx.ajax.xhrUtil({
        url: url + query,
        method: method,
        data: data,
        headers: options.headers,
        timeout: options.timeout,
        async: options.async,
        success: function (res) {
            if (typeof callback === 'function') callback(res, null);
        },
        error: function (err) {
            if (typeof callback === 'function') callback(null, err);
        }
    });
};

ttx.proxy.get = function (props, url, params, callback) {
    ttx.proxy.forward(props, { url: url, method: 'get', query: params }, null, callback);
};

ttx.proxy.post = function (props, url, data, callback) {
    ttx.proxy.forward(props, { url: url, method: 'post' }, data, callback);
};

ttx.proxy.request = function (options) {
    const config = options || {};
    return new Promise(function (resolve, reject) {
        ttx.proxy.forward(
            config.props,
            {
                url: config.url,
                method: config.method || 'post',
                query: config.query,
                headers: config.headers,
                timeout: config.timeout,
                async: config.async
            },
            config.data,
            function (res, err) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(res);
            }
        );
    });
};

// ============================================================
// MDF Proxy/Transfer API 补齐
// ============================================================

/**
 * 跨域转发，解决跨服务调用越权
 * 对应 MDF cb.proxy.transferCommonRest
 *
 * 转发到 ttx.rest.transferCommonRest 实现，回调签名 callback(err, result)
 *
 * options:
 *   params: { url, targetServiceKey, method, parameter }  — 必传：targetServiceKey、method、url
 *   domainKey — 领域编码
 *   query     — 附加 query
 *   mask      — 是否显示遮罩
 *   proxyKey  — 代理 key
 *
 * 公共转发规则（Node 侧）：
 *   - /uniform 开头：JSON 形式转到 Java 服务
 *   - /formdata 开头：FormData 形式转到 Java 服务
 *   - /uniformdata 开头：原封透传到 Java 服务
 *   - Node 对所有过境请求流量限制最大 50M
 *
 * @param {object} viewmodel 页面级模型
 * @param {object} options 转发配置
 * @param {function} [callback] 回调 (err, result)
 */
ttx.proxy.transferCommonRest = function (viewmodel, options, callback) {
    var opts = options || {};
    // 参数校验：params 必传，且 params.targetServiceKey/method/url 必传
    if (!opts.params) {
        ttx.console.error('[ttx.proxy.transferCommonRest] params 参数缺失');
        if (typeof callback === 'function') callback(new Error('params 参数缺失'));
        return;
    }
    if (!opts.params.targetServiceKey || !opts.params.method || !opts.params.url) {
        ttx.console.error('[ttx.proxy.transferCommonRest] params.targetServiceKey/method/url 必传');
        if (typeof callback === 'function') callback(new Error('targetServiceKey/method/url 必传'));
        return;
    }
    // 委托给 ttx.rest.transferCommonRest（已实现，回调签名一致：err, result）
    if (ttx.rest && typeof ttx.rest.transferCommonRest === 'function') {
        return ttx.rest.transferCommonRest(viewmodel, opts, callback);
    }
    ttx.console.error('[ttx.proxy.transferCommonRest] ttx.rest.transferCommonRest 未实现');
    if (typeof callback === 'function') callback(new Error('transferCommonRest 未实现'));
};
